export default __webpack_public_path__ + "static/media/docker.75a949a6.svg";